import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Typography from '@mui/material/Typography';
import WaitinglistList from "../partials/list/WaitinglistList";
import { BoxContainer } from '../layouts/Theme';
import { useI18N } from '../context/I18NContext';
import { useTheme } from '@mui/material';
export default function Waitinglists(props) {
    const { t } = useI18N();
    const theme = useTheme();
    return (_jsxs(BoxContainer, { children: [_jsx(Typography, { sx: { color: theme.palette.text.primary }, variant: "h6", children: t('Wachtlijsten') }), _jsx(WaitinglistList, {})] }));
}
